module.exports = __webpack_public_path__ + "static/media/406SunsetAveNW_2018-06-11_155.b4216305.jpg";